export default __webpack_public_path__ + "static/media/logo.84e8a3d3.png";